import type { ReactNode } from 'react';

export const symbol_android_wifi_3_bar_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M430.5-181.5Q410-202 410-231t20.5-49.5Q451-301 480-301t49.5 20.5Q550-260 550-231t-20.5 49.5Q509-161 480-161t-49.5-20.5ZM319-512l-130-90-16 10q-8 5-16 11-19 14-42 13.5T75-585q-16-17-15-39.5T79-661q3-2 6.5-4.5T92-670l-28-19q-14-10-16.5-26t7.5-30q10-14 25.5-17t29.5 7l726 507q14 10 16.5 26t-7.5 30q-10 14-25.5 16.5T790-183L423-439q-26 5-50.5 14T325-402q-19 11-40 9.5T249-409q-14-15-13.5-35.5T253-476q16-11 32.5-19.5T319-512Zm19-157-112-78q60-26 124-39t130-13q110 0 212.5 35.5T881-661q18 14 19 36.5T885-585q-17 17-40 17.5T803-581q-70-52-152.5-79.5T480-688q-36 0-71.5 4.5T338-669Z"
		/>
	</svg>
);
